import { UserReactionRequest } from './Reaction.api.type';

/**
 * 유저 반응관련 초기화 모음
 */
export const reactionInitializer = {
  /**
   * 유저 리액션 요청 파라미터 초기화
   */
  INITIAL_USER_REACTION_PARAM: {
    questionId: '',
    reactionType: 'LIKE', // 기본값은 'LIKE'
    fingerprint: undefined, // 선택적 필드로 초기화
  } as UserReactionRequest,
};
